export default __webpack_public_path__ + "85661d580617e2825f7a5934d7362b74.png";